var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","height":"24","viewBox":"0 -960 960 960","width":"24"}},_vm.$listeners),[_c('path',{attrs:{"d":"M160-360v-80h640v80H160zm0-160v-80h640v80H160z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }